/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC, PropsWithChildren } from 'react';
import { ButtonProps } from './types';
import { Styles } from './styles';

export const Button: FC<PropsWithChildren<ButtonProps>> = ({ role, size = 'normal', type = 'secondary', isFull, ...props }) => (
  <button
    {...props}
    css={[
      Styles.sizes[size],
      Styles.types[type],
      Styles.button,
      isFull ? { width: '100%' } : {}
    ]}
    role={role}
    type={role === 'submit' ? 'submit' : 'button'}
  />
);
